import gsap from 'gsap';
import { html } from '@resn/gozer-core';
import { autobind } from 'core-decorators';

import store from 'core/store';
import { Component, componentMixin } from '@resn/gozer-core/component';

import AssetsMixin from 'utils/loading/assets-mixin';
import DomComponentMixin from '@resn/gozer-core-mixins/dom-component';
import { deviceBenchmark } from 'utils/device-benchmark';

import PageMixin from 'page/base/page-mixin';
import PageFallbackMixin from 'page/base/page-fallback-mixin';
import * as Sections from 'component/sections/home';

import data from './data';

import './index.scss';
import ScrollService from 'utils/services/scroll-service';
import { darkLandingHeaderProps, standardHeaderProps } from 'data/header-data';

const template = () => html` <div class="page-base  home"></div> `;

@componentMixin(AssetsMixin())
@componentMixin(deviceBenchmark.fallback ? PageFallbackMixin : PageMixin)
@componentMixin(DomComponentMixin)
class PageHome extends Component {
    options = {
        template,

        ...standardHeaderProps,
    };

    props = {
        enter: false,
        active: false,
    };

    assets = {
        // hero: 'static/images/pages/home/hero-xp1.png#imgo',
        feature1Graphic: 'static/images/pages/home/home-maximizepotential-lines.svg#img',
        feature1Img: 'static/images/pages/home/home-maximizepotential-athlete.png#imgo',
        feature2Img: 'static/images/pages/home/home-techmeetstraining.png#imgo',
        feature3Img: 'static/images/pages/home/home-connectedecosystem.png#imgo',

        discoverGraphic: 'static/images/pages/home/home-explorexp1-lines.svg#img',
        discoverImg: 'static/images/pages/home/hero-xp1.png#imgo',
    };

    async onSetup() {
        await this.addSections();
    }

    async addSections() {
        const sections = data.sections.slice();

        for (let index = 0; index < sections.length; index++) {
            const sectionData = sections[index];
            const Class = sectionData.class;

            const section = await new Class().setup({
                options: {
                    id: sectionData.id,
                    name: sectionData.id,
                    index,
                    appendTo: this.el,
                    ...(sectionData.options ? sectionData.options : {}),
                },
                props: {
                    x: () => this.props.x,
                    delta: () => store().state.clock.delta,
                    active: (props) =>
                        this.props.active && this.props.enter && props.intersecting && !store().state.menu.opened,
                },
            });

            this.sections.push(section);
        }
    }
}

export default PageHome;
